import { useEffect, useMemo, useState } from "react";

/**
 * The sites shown so far, kept while the trace runs: a settled call no longer
 * carries the sites its snapshots named (its result holds the pages it kept),
 * and the favicons are the one moving proof that the search is finding
 * things — the row must not empty between a search and the next one.
 */
export function useKeptDomains(domains: readonly string[]): readonly string[] {
  const [kept, setKept] = useState<readonly string[]>([]);
  const signature = domains.join("\n");

  useEffect(() => {
    if (!signature) return;
    setKept((previous) => {
      const added = signature
        .split("\n")
        .filter((domain) => !previous.includes(domain));
      return added.length > 0 ? [...previous, ...added] : previous;
    });
  }, [signature]);

  return useMemo(
    () => [...new Set([...kept, ...signature.split("\n").filter(Boolean)])],
    [kept, signature]
  );
}

